import { defineMessages } from 'react-intl';

export const translations = defineMessages({
    projectDate: {
        id: 'Project.editDialog.date', defaultMessage: 'Project date'
    }
});